import { useState, useEffect } from "react";
import { message, Modal } from "antd";
import { DropzoneArea } from 'material-ui-dropzone';
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import QuoteForm from "../Components/QuoteForm";
import CardSection from "../Components/CardSection";
import { url, header } from "../Constent/Constant";

function MilitaryMoving() {
  const [MilitaryMovingData, setMilitaryMovingData] = useState('')
  const [HeadingUpdate, setHeadingUpdate] = useState('')
  const [TextModalVisible, setTextModalVisible] = useState(false);
  const [ImageUpdate, setImageUpdate] = useState(null)
  const [ImageModal, setImageModal] = useState(false);
  const [UpdateId, setUpdateId] = useState('')
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if(LoggedIn !== 'true'){
    history.push('/')
  }

  useEffect(() => {
    UpdateData()
  }, [])

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: 'POST',
      body: JSON.stringify({
        name: "Military Moving"
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setMilitaryMovingData(data.doc)
      })
  }

  const OnFormFill = (ObjectData) => {
    if (ObjectData !== null) {
      fetch(`${url}/page/requestaquote`, {
        method: 'POST',
        body: JSON.stringify({
          data: {
            firstname: ObjectData.fName,
            lastname: ObjectData.lName,
            email: ObjectData.email,
            phone: ObjectData.phone
          }
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            message.success('Thank You')
          }
        })
    } else {
      console.error('Not fill Correctly')
    }
  }


  const UpdateText = (DataObject) => {
    console.log(DataObject)
    if (DataObject !== '') {
      fetch(`${url}/page/updatedata`, {
        method: 'POST',
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            UpdateData()
          }
        })
    }
  }

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append('image', DataObject.image)
    Imagedata.append('id', DataObject.id)

    fetch(`${url}/page/updateimage`, {
      method: 'POST',
      body: Imagedata
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.message === 'Success') {
          UpdateData()
        }
      })
  }

  const handleCancel = () => {
    setTextModalVisible(false);
    setImageModal(false);
  };

  const ShowTextModal = (id) => {
    setTextModalVisible(true);
    setUpdateId(id)
  };

  const showImageModal = (id) => {
    setImageModal(true);
    setUpdateId(id)
  };

  const TextHandle = () => {
    if (HeadingUpdate === '') {
      message.error('Fill the Field')
    } else {
      UpdateText({
        text: HeadingUpdate,
        id: UpdateId
      })
      setTextModalVisible(false);
      setHeadingUpdate('')
    }
  };

  const OnImageHandle = () => {
    if (ImageUpdate === null) {
      message.error('Insert Image')
    } else {
      UpdateImage({
        image: ImageUpdate,
        id: UpdateId
      })
      setImageModal(false);
    }
  };

  const OnEnterPress = (event) => {
    const a = HeadingUpdate
    console.log(a)
    if (event.key === 'Enter') {
      console.log('Enter Clicked')
      a.concat('\n')
      setHeadingUpdate(a)
    } else {
      console.log(event.key)
    }
  }



  return (
    <Layout>
      {MilitaryMovingData && <Header
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={{
          imgId: MilitaryMovingData.section1image1._id,
          headingId: MilitaryMovingData.section1heading1._id
        }}
        Image={MilitaryMovingData.section1image1.image} />}

      <div className='Military-Heading'>
        <h2>{MilitaryMovingData ? MilitaryMovingData.section2heading1.content : 'No Text'}
          <i onClick={() => ShowTextModal(MilitaryMovingData.section2heading1._id)} className="far fa-edit Edit-btn"></i>
        </h2>
        <p> {MilitaryMovingData ? MilitaryMovingData.section2paragraph1.content : 'No Text'}
          <i onClick={() => ShowTextModal(MilitaryMovingData.section2paragraph1._id)} className="far fa-edit Edit-btn"></i>
        </p>
      </div>

      {MilitaryMovingData &&
        <div className='Military-Card-div'>
          <CardSection Background='CardSec-Container-Secondary'
            UpdateText={UpdateText}
            UpdateImage={UpdateImage}
            CardData={{
              card1: {
                img: MilitaryMovingData.section3image1.image,
                imgId: MilitaryMovingData.section3image1._id,
                heading: MilitaryMovingData.section3heading1.content,
                headingId: MilitaryMovingData.section3heading1._id,
                para: MilitaryMovingData.section3paragraph1.content,
                paraId: MilitaryMovingData.section3paragraph1._id,
              },
              card2: {
                img: MilitaryMovingData.section3image2.image,
                imgId: MilitaryMovingData.section3image2._id,
                heading: MilitaryMovingData.section3heading2.content,
                headingId: MilitaryMovingData.section3heading2._id,
                para: MilitaryMovingData.section3paragraph2.content,
                paraId: MilitaryMovingData.section3paragraph2._id,
              },
              card3: {
                img: MilitaryMovingData.section3image3.image,
                imgId: MilitaryMovingData.section3image3._id,
                heading: MilitaryMovingData.section3heading3.content,
                headingId: MilitaryMovingData.section3heading3._id,
                para: MilitaryMovingData.section3paragraph3.content,
                paraId: MilitaryMovingData.section3paragraph3._id,
              }
            }} />
        </div>}

      <div className='Military-Conatiner'>
        {MilitaryMovingData && <Header
          UpdateText={UpdateText}
          UpdateImage={UpdateImage}
          GetData={{
            imgId: MilitaryMovingData.section4image1._id,
            headingId: MilitaryMovingData.section4heading1._id
          }}
          Image={MilitaryMovingData.section4image1.image}
          Heading={MilitaryMovingData.section4heading1.content} />}
        <button className='Button Contact-btn'>Contact Us</button>
      </div>

      {MilitaryMovingData && <div className='Commercial-Quote'>
        <h2> {MilitaryMovingData.section5heading1.content}
        <i onClick={() => ShowTextModal(MilitaryMovingData.section5heading1._id)} className="far fa-edit Edit-btn"></i>
        </h2>
        <div className='Commercial-Section'>
          <div className='Commercial-left-box'>
            <i onClick={() => showImageModal(MilitaryMovingData.section5image1._id)} className="far fa-edit Edit-btn"></i>
            <img src={`${url}/api/getFile${MilitaryMovingData.section5image1.image}`} alt="Img" />
          </div>
          <div className='Commercial-right-box'>
            <QuoteForm OnSubmit={OnFormFill} />
          </div>
        </div>
      </div>}


      {/* Update Text Modal */}
      <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
        <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
      </Modal>

      {/* Update Image Modal */}
      <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
        <DropzoneArea
          filesLimit={1}
          acceptedFiles={['image/*']}
          dropzoneText={"Update Product Images"}
          onChange={(files) => {
            console.log('Files:', files[0])
            setImageUpdate(files[0])
          }}
        />
      </Modal>

    </Layout>
  );
}

export default MilitaryMoving;
